import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FrogFace } from "@/components/FrogArt";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";

export default function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#F0F9FF] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="max-w-md w-full bg-white rounded-3xl border border-slate-100 shadow-lg p-10 text-center space-y-4">
        <FrogFace size={80} className="mx-auto" />
        <h1 data-testid="payment-cancel-title" className="font-display text-2xl font-bold text-slate-800">Tip cancelled</h1>
        <p className="text-slate-500 text-sm">No worries — no card was charged. The tadpole still loves you.</p>
        <Button data-testid="tip-back-home-btn" onClick={() => nav("/home")} className="btn-tactile h-12 rounded-xl bg-gradient-to-br from-sky-500 via-cyan-500 to-blue-500 hover:brightness-110 text-white font-display font-semibold">
          <Home className="w-4 h-4 mr-2" /> Back to the pond
        </Button>
      </motion.div>
    </div>
  );
}
